import { c as _c } from "react/compiler-runtime";
import { Suspense } from 'react';
import { ClientSidePagination } from '@/app/[locale]/_components/Pagination/index.client';
import PaginationRenderer from '@/app/[locale]/_components/Pagination/PaginationRenderer';
import type { PaginationProps } from '@/app/[locale]/_components/Pagination/types';
import { getPagination } from '@/lib/pagination';
export function Pagination(t0) {
  const $ = _c(8);
  let currPage;
  let props;
  let t1;
  if ($[0] !== t0) {
    const {
      currentPage,
      ...t2
    } = t0;
    props = t2;
    currPage = currentPage ?? 1;
    t1 = getPagination({
      currentPage: currPage,
      totalPages: props.totalPages
    });
    $[0] = t0;
    $[1] = currPage;
    $[2] = props;
    $[3] = t1;
  } else {
    currPage = $[1];
    props = $[2];
    t1 = $[3];
  }
  const pagination = t1;
  let t2;
  if ($[4] !== currPage || $[5] !== pagination || $[6] !== props) {
    t2 = <Suspense fallback={<SSRPagination {...props} pagination={pagination} currentPage={currPage} />}><ClientSidePagination {...props} pagination={pagination} currentPage={currPage} /></Suspense>;
    $[4] = currPage;
    $[5] = pagination;
    $[6] = props;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
function SSRPagination(t0) {
  const $ = _c(6);
  const {
    totalPages,
    currentPage: t1,
    pathname,
    useSearchParamPagination,
    pagination
  } = t0;
  const currentPage = t1 === undefined ? 1 : t1;
  let t2;
  if ($[0] !== currentPage || $[1] !== pagination || $[2] !== pathname || $[3] !== totalPages || $[4] !== useSearchParamPagination) {
    t2 = <PaginationRenderer totalPages={totalPages} currentPage={currentPage} pathname={pathname} useSearchParamPagination={useSearchParamPagination} pagination={pagination} />;
    $[0] = currentPage;
    $[1] = pagination;
    $[2] = pathname;
    $[3] = totalPages;
    $[4] = useSearchParamPagination;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}